import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

export default function Steptwo({
  delegates,
  selectedPass,
  qtyByPass,
  setQtyByPass,
  delegateData,
  setDelegateData,
  termsAccepted,
  setTermsAccepted,
  showPaymentOptions,
  bookingId,
  paymentError,
  processing,
  handleSubmitBooking,
  handleStartPayPal,
  handleStartRazorpay,
  paypalRef,
}) {
  const [successMessage, setSuccessMessage] = useState("");

  if (!selectedPass) return null;

  const delegateSchema = Yup.object().shape({
    delegates: Yup.array().of(
      Yup.object().shape({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        company: Yup.string().required("Company is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        mobile: Yup.string().required("Mobile number is required"),
      })
    ),
    termsAccepted: Yup.bool().oneOf([true], "You must accept terms"),
  });

  const initialValues = {
    delegates: [...Array(delegates)].map((_, i) => ({
      firstName: delegateData[i]?.firstName || "",
      lastName: delegateData[i]?.lastName || "",
      company: delegateData[i]?.company || "",
      email: delegateData[i]?.email || "",
      mobile: delegateData[i]?.mobile || "",
    })),
    termsAccepted,
  };

  const handleFormSubmit = async (values) => {
    // Prepare payload directly from Formik values
    const delegatesPayload = values.delegates.map((d) => ({
      ...d,
      passType: selectedPass.title,
    }));

    // Update state if needed
    setDelegateData(
      delegatesPayload.reduce((acc, d, i) => ({ ...acc, [i]: d }), {})
    );
    setTermsAccepted(values.termsAccepted);

    const success = await handleSubmitBooking(delegatesPayload); // Pass delegates directly
    if (success) setSuccessMessage("✅ Booking saved. Complete payment below.");
  };

  return (
    <div className="delegate-form">
      <style>{`
        .delegate-form .form-control,
        .delegate-form .react-tel-input .form-control {
          background-color: #fff !important;
          border: 1px solid #ced4da !important;
          border-radius: 6px !important;
          padding: 10px 12px !important;
          height: auto !important;
          font-size: 1rem !important;
          color: #000 !important;
        }
        .delegate-form .react-tel-input {
          background: #fff !important;
        }
        .delegate-form .react-tel-input .flag-dropdown {
          background-color: #fff !important;
          border: 1px solid #ced4da !important;
          border-radius: 6px 0 0 6px !important;
        }
        .delegate-form .form-check-input {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
        .delegate-form .btn-outline-primary {
          border: 1px solid #007bff;
          color: #007bff;
          font-weight: 500;
        }
        .delegate-form .btn-primary {
          background-color: #007bff;
          border: none;
          font-weight: 600;
          padding: 10px 18px;
        }
        .delegate-card {
          background-color: #fff !important;
          border: 1px solid #eee;
        }
      `}</style>

      <h3 className="fw-bold mb-4">Enter Delegate Details</h3>

      {successMessage && (
        <div className="alert alert-success">{successMessage}</div>
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={delegateSchema}
        onSubmit={handleFormSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue }) => (
          <Form>
            {values.delegates.map((_, i) => (
              <div key={i} className="delegate-card p-4 rounded mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="m-0">
                    Delegate {i + 1} {i === 0 && "(Primary)"}
                  </h6>
                  {delegates > 1 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() =>
                        setQtyByPass((q) => ({
                          ...q,
                          [selectedPass.id]: Math.max(1, q[selectedPass.id] - 1),
                        }))
                      }
                    >
                      Remove
                    </button>
                  )}
                </div>

                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <Field
                      name={`delegates[${i}].firstName`}
                      className="form-control"
                      placeholder="First Name *"
                    />
                    <ErrorMessage
                      name={`delegates[${i}].firstName`}
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name={`delegates[${i}].lastName`}
                      className="form-control"
                      placeholder="Last Name *"
                    />
                    <ErrorMessage
                      name={`delegates[${i}].lastName`}
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name={`delegates[${i}].company`}
                      className="form-control"
                      placeholder="Company *"
                    />
                    <ErrorMessage
                      name={`delegates[${i}].company`}
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name={`delegates[${i}].email`}
                      type="email"
                      className="form-control"
                      placeholder="Email Address *"
                    />
                    <ErrorMessage
                      name={`delegates[${i}].email`}
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <PhoneInput
                      country={"us"}
                      value={values.delegates[i].mobile}
                      onChange={(value) =>
                        setFieldValue(`delegates[${i}].mobile`, value)
                      }
                      inputClass="form-control"
                    />
                    <style>{`
  .delegate-form .form-control,
  .delegate-form .react-tel-input .form-control {
    background-color: #fff !important;
    border: 1px solid #ced4da !important;
    border-radius: 6px !important;
    padding: 10px 12px !important;
    height: auto !important;
    font-size: 1rem !important;
    color: #000 !important;
    padding-left: 60px !important; /* added for flag spacing */
  }
  .delegate-form .react-tel-input .flag-dropdown {
    background-color: #fff !important;
    border: 1px solid #ced4da !important;
    border-radius: 6px 0 0 6px !important;
  }
`}</style>

                    <ErrorMessage
                      name={`delegates[${i}].mobile`}
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-outline-primary mt-2"
              onClick={() =>
                setQtyByPass((q) => ({
                  ...q,
                  [selectedPass.id]: q[selectedPass.id] + 1,
                }))
              }
            >
              + Add Another Delegate
            </button>

            <div className="form-check mt-4">
              <Field
                type="checkbox"
                name="termsAccepted"
                id="termsAccepted"
                className="form-check-input"
              />
              <label className="form-check-label small" htmlFor="termsAccepted">
                Please tick to confirm your agreement to the{" "}
                <a href="/terms">terms and conditions</a>
              </label>
              <ErrorMessage
                name="termsAccepted"
                component="div"
                className="text-danger small mt-1"
              />
            </div>

            <div className="d-flex gap-2 mt-3">
              {!showPaymentOptions && (
                <button
                  type="submit"
                  className="btn btn-primary position-relative"
                  disabled={processing}
                >
                  {processing ? (
                    <span className="website-loader"></span>
                  ) : (
                    "Submit & Proceed to Pay →"
                  )}
                </button>
              )}
            </div>
          </Form>
        )}
      </Formik>

      {showPaymentOptions && (
        <div className="mt-4">
          <h5>Complete Payment</h5>
          <p className="small text-muted">
            Booking reference: <strong>{bookingId}</strong>
          </p>

          {paymentError && (
            <div className="text-danger mb-2">{paymentError}</div>
          )}

          <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
            <button
              className="btn"
              onClick={handleStartPayPal}
              disabled={processing}
              style={{
                border: "1px solid #003087",
                background: "#fff",
                color: "#003087",
                padding: "10px 16px",
                borderRadius: 8,
                fontWeight: 700,
              }}
            >
              {processing ? <span className="website-loader"></span> : "Pay with PayPal (USD)"}
            </button>

            <button
              className="btn"
              onClick={handleStartRazorpay}
              disabled={processing}
              style={{
                border: "1px solid #3399cc",
                background: "#fff",
                color: "#3399cc",
                padding: "10px 16px",
                borderRadius: 8,
                fontWeight: 700,
              }}
            >
              {processing ? <span className="website-loader"></span> : "Pay with Razorpay (INR)"}
            </button>
          </div>

          <div
            ref={paypalRef}
            id="paypal-button-container"
            style={{ marginTop: 16 }}
          ></div>

        </div>
        
      )}
    </div>
  );
}
